<template>
    <van-overlay :show="showed" :lock-scroll="lockScroll" v-bind="$attrs" :z-index="3000">
        <div class="dialog" @click.stop>
            <div class="dialog-content">
                <div class="title">{{ $t('menu_bind_phone') }}</div>
                <div class="input-wrap">
                    <div class="bind-label">
                        <CountyMobile @countryCodeChange="changeCode" />
                    </div>
                    <van-field class="bind-input" v-model="phoneNum" type="digit" :maxlength="15" :placeholder="$t('Enter_mobile_number')" />
                </div>
                <div class="input-wrap code-input">
                    <div class="bind-label" @click.stop="sendCode">
                        <div class="sended" v-if="codeOpt.isSend">
                            <span v-if="codeOpt.timer">({{ codeOpt.seconds }}s)<br /></span>
                            <span :class="{ 'text-[#000]': !codeOpt.timer }"> {{ $t('Resend') }}</span>
                        </div>
                        <div :class="!!phoneNum ? 'text-[#fff]' : 'text-[#fff]'" v-else>{{ $t('send code') }}</div>
                    </div>
                    <van-field class="bind-input" v-model="codeNum" type="digit" :placeholder="$t('Enter_verification_code')" :maxlength="6" />
                </div>
                <div class="red-tip">{{ $t('bind_phone_security_info') }}</div>
                <div class="bind-btn" @click="handleBind">{{ $t('Bind') }}</div>
            </div>
            <div v-if="showClose" class="close-icon" @click="handleClose"></div>
        </div>
    </van-overlay>
</template>
<script lang="ts" setup>
import { useCutdown } from '@/hooks/useCutdown'
import CountyMobile from '../countyMobile.vue'
import { useBaseStore } from '@/stores'
import * as service from '@/api'
import md5 from 'md5'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { useI18n } from 'vue-i18n'
import popupManager from '@/utils/PopupManager'
import eventbus from '@/utils/bus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: () => false,
    },
    showClose: {
        type: Boolean,
        default: () => true,
    },
    lockScroll: {
        type: Boolean,
        default: () => false,
    },
    title: {
        type: String,
        default: () => '',
    },
    canClosed: {
        type: Boolean,
        default: () => true,
    },
    tip: {
        type: String,
        default: () => '',
    },
    type: {
        type: Number,
        default: () => 0,
    },
})
const store = useBaseStore()
const i18n = useI18n()
//

const { codeOpt, doCutDown } = useCutdown()

const emits = defineEmits(['close', 'update:modelValue', 'confirm'])
const showed = defineModel()
const phoneNum = ref('')
const codeNum = ref('')
const areaCode = ref('')

const handleClose = () => {
    if (!props.canClosed) {
        return
    }
    showed.value = false
    store.closeBind = true
    !props.type && eventbus.emit('pointAnimate')
    popupManager.checkQueue()
    emits('close')
}
const handleBind = async () => {
    if (!codeNum.value || !phoneNum.value) {
        return
    }
    // @ts-ignore
    if (!isValidPhoneNumber('+' + areaCode.value + phoneNum.value)) {
        return showToast(i18n.t('Please_enter_a_valid'))
    }
    if (!/\d{4}/.test(`${codeNum.value}`)) {
        return showToast(i18n.t('Incorrect_verification'))
    }
    const res = await service.bindPhone({
        country: 'PH', //国家
        code: codeNum.value, //验证码
        telephone: phoneNum.value, //手机号
    })
    if (res.code === 200) {
        store.showSuccessToast(i18n.t('Binding_successful'))
        store.getProfile()
        emits('confirm')
        !props.type && eventbus.emit('pointAnimate')
        showed.value = false
        popupManager.checkQueue()
    }
}
const sendCode = () => {
    if (!phoneNum.value) {
        return showToast(i18n.t('Please_enter_a_valid'))
    }
    // @ts-ignore
    if (!isValidPhoneNumber('+' + areaCode.value + phoneNum.value)) {
        return showToast(i18n.t('Please_enter_a_valid'))
    }
    if (codeOpt.timer) {
        return
    }
    codeOpt.times = codeOpt.times + 1
    try {
        service
            .getSms({
                apptitle: 'h5',
                country: 'PH',
                grant: 'bindtelephone',
                sendnum: codeOpt.times,
                sign: md5(phoneNum.value),
                telephone: phoneNum.value,
                zIndex: 3001,
            })
            .then((res) => {
                if (res.code === 200) {
                    codeOpt.isSend = true
                    doCutDown()
                    showToast(i18n.t('Verification_code_ha'))
                }
                // else {
                //     showToast(i18n.t('Send_failed_wait'))
                // }
            })
    } catch (e) {
        console.log(e, 'eeeeeee')
    }
}

const changeCode = (code) => {
    areaCode.value = code
}
const getVipInfo = async (loading = true) => {
    try {
        const info = await store.getVipInfo(loading)
        if (info.code === 200) {
            store.setvipInfo(info)
            if (store.vipInfo.exp) {
                showed.value = true
            } else {
                popupManager.checkQueue()
            }
        } else {
            popupManager.checkQueue()
        }
    } catch (e) {
        console.log(e)
        popupManager.checkQueue()
    }
}
onBeforeMount(() => {
    if (props.type === 2) {
        return
    }
    if ((props.type === 0 && store.closeBind) || store.userInfo?.telephone) {
        return popupManager.checkQueue()
    }
    if (!store.userInfo.telephone || props.type === 1) {
        if (props.type === 0) {
            if (Object.keys(store.vipInfo).length) {
                if (store.vipInfo.exp) {
                    showed.value = true
                } else {
                    popupManager.checkQueue()
                }
            } else {
                getVipInfo()
            }
        } else {
            showed.value = true
        }
    }
})
</script>
<style scoped lang="scss">
.dialog {
    @apply flex flex-col;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 690px;
    max-height: 900px;
    font-family: MicrosoftYaHei;
    color: #fff;

    transform: translate3d(-50%, -50%, 0);
}
.dialog-content {
    padding-bottom: 40px;

    min-height: 570px;
    border-radius: 30px;
    background: #42355a;

    .title {
        @apply flex justify-center items-center;
        position: relative;
        top: -36px;
        margin: 0 auto;
        width: 470px;
        height: 96px;
        padding-bottom: 20px;
        background: url('@/assets/img/dialog/bind_title.png') no-repeat;
        background-size: 100% 100%;
        font-size: 36px;
        font-weight: bold;
    }
    .input-wrap {
        display: flex;
        width: 620px;
        height: 104px;
        margin: 30px auto;
        border-radius: 30px;
        background: #2f213b;

        .bind-label {
            position: relative;
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            font-weight: bold;
            color: #fff;
            text-align: center;
            line-height: 30px;

            &::before {
                position: absolute;
                right: 0;
                content: '';
                width: 4px;
                height: 56px;
                background-color: #747a8d;
            }
            .sended {
                color: #999999;
            }
            :deep(.code-icon) {
                width: 50px;
                text-indent: 12px;
            }
            :deep(.coutry) {
                &::after {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-left: 10px solid transparent; /* 左边框透明 */
                    border-right: 10px solid transparent; /* 右边框透明 */
                    border-top: 10px solid #fff; /* 顶部边框为黑色，形成尖角 */
                }
            }
            :deep(.coutry-input) {
                text-align: center;
                // padding-right: 0;
            }
        }
        .bind-input {
            border-radius: 0 52px 52px 0;
        }
        :deep(.van-field__body) {
            height: 100%;

            .van-field__control {
                font-size: 36px;
                color: #ffffff;

                &::placeholder {
                    font-size: 32px;
                    color: #8e80a8;
                }
            }
        }
        :deep(.van-cell) {
            background: #2f213b;
            border-radius: 22px;
        }
    }
    .code-input {
        // margin-bottom: 85px;
    }
    .bind-btn {
        margin: 0 auto;
        width: 400px;
        height: 88px;
        line-height: 88px;
        font-size: 48px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        border-radius: 100px;
        background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
        box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset;
    }
    .red-tip {
        margin: 0 auto 16px;
        width: 378px;
        font-family: MicrosoftYaHei;
        font-size: 24px;
        color: #ff5688;
        text-align: center;
        &::before {
            display: inline-block;
            content: '';
            position: relative;
            top: 5px;
            width: 30px;
            height: 26px;
            background: url('@/assets/img/wallets/exclam_mark.png') no-repeat;
            background-size: 100% 100%;
        }
    }
}
.close-icon {
    position: absolute;
    top: 21px;
    right: 21px;
    width: 64px;
    height: 64px;
    background: url('@/assets/img/home-notice/close.png') no-repeat right top;
    background-size: 32px 32px;
}
</style>
